import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TableCell,
  TableRow,
  TextField,
} from '@mui/material';
import { FilterMappingProps, FilterProps } from '../CommonModel';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import EmailAdminConstants from '../../Layout/EmailAdministration/Common/Constants';
import { useState } from 'react';

export const CustomerFilter = (props: FilterProps) => {
  if (props.filterOption === 'email' && props.setEmail != undefined) {
    return (
      <>
        <TableRow>
          <TableCell>
            <ContactMailIcon fontSize="large" />
          </TableCell>
          <TextField
            name="email"
            multiline
            sx={{ width: 350 }}
            maxRows={3}
            fullWidth
            helperText={EmailAdminConstants.EmapleExamplehlperText}
            value={props.email}
            onChange={(e) => props.setEmail && props.setEmail(e.target.value)}
          />
        </TableRow>
      </>
    );
  } else if (
    props.filterOption === 'farm' ||
    props.filterOption === 'customer' ||
    props.filterOption === 'tags'
  ) {
    return (
      <div style={{ padding: 5 }}>
        <DisplaySendToItems
          checkboxList={props.FilterMapping[props.filterOption].checkboxList}
          setCheckBoxList={
            props.FilterMapping[props.filterOption].setCheckBoxList
          }
        />
      </div>
    );
  }
};

const DisplaySendToItems = (props: FilterMappingProps) => {
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAllChange = (e: { target: { checked: boolean } }) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    const updatedList = props.checkboxList.map((item) => ({
      ...item,
      Check: checked,
    }));
    props.setCheckBoxList(updatedList);
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox checked={selectAll} onChange={handleSelectAllChange} />
        }
        label="Select All"
      />
      {props.checkboxList.map((item, index) => (
        <FormControlLabel
          key={item.Text}
          control={
            <Checkbox
              key={item.Text}
              checked={item.Check}
              name={item.Text}
              onChange={(e) => {
                const updatedList = [...props.checkboxList];
                updatedList[index] = {
                  ...updatedList[index],
                  Check: e.target.checked,
                };
                props.setCheckBoxList(updatedList);
              }}
            />
          }
          label={item.Text}
        />
      ))}
    </FormGroup>
  );
};
